<template>
    <div>
        <div>
            <div style="display: flex;justify-content: space-between">
                <div>
                    <el-input placeholder="输入项目名称模糊检索" prefix-icon="el-icon-search"
                              clearable
                              @clear="initOfflineProjects"
                              style="width: 350px;margin-right: 10px" v-model="keyword"
                              @keydown.enter.native="initOfflineProjects" :disabled="showAdvanceSearchView"></el-input>
                    <el-button icon="el-icon-search" type="primary" @click="initOfflineProjects" :disabled="showAdvanceSearchView">
                        搜索
                    </el-button>
                    <el-button type="primary" @click="showAdvanceSearchView = !showAdvanceSearchView">
                        <i :class="showAdvanceSearchView?'fa fa-angle-double-up':'fa fa-angle-double-down'"
                           aria-hidden="true"></i>
                        高级搜索
                    </el-button>
                </div>
                <div>
                    <!-- <el-upload
                            :show-file-list="false"
                            :before-upload="beforeUpload"
                            :on-success="onSuccess"
                            :on-error="onError"
                            :disabled="importDataDisabled"
                            style="display: inline-flex;margin-right: 8px"
                            action="/employee/basic/import">
                        <el-button :disabled="importDataDisabled" type="success" :icon="importDataBtnIcon">
                            {{importDataBtnText}}
                        </el-button>
                    </el-upload> -->
                    <!-- <el-button type="success" @click="importData" icon="el-icon-download">
                        {{importDataBtnText}}
                    </el-button>
                    <el-button type="success" @click="exportData" icon="el-icon-download">
                        导出项目
                    </el-button> -->
                    
                    <el-button type="primary" icon="el-icon-plus" @click="showAddEmpView">
                        添加项目
                    </el-button>
                </div>
            </div>

            <!-- 高级搜索条件  -->
            <transition name="slide-fade">
                <div v-show="showAdvanceSearchView"
                     style="border: 1px solid #409eff;border-radius: 5px;box-sizing: border-box;padding: 5px;margin: 10px 0px;">
                    <el-row>
                        <el-col :span="4">
                            项目名称:
                            <el-input v-model="searchValue.keyword" placeholder="项目名称" clearable size="mini"
                                       style="width: 130px;"></el-input>
                        </el-col>
                        <el-col :span="4">
                                年度：<el-date-picker
                                                v-model="searchValue.year"
                                                type="year"
                                                size="mini"
                                                style="width: 125px;"
                                                format="yyyy"
                                                value-format="yyyy"
                                                placeholder="活动时间">
                                        </el-date-picker>
                        </el-col>
                        <el-cal :span="4">
                                项目时间：<el-date-picker
                                                            v-model="searchValue.timeRange"
                                                            type="daterange"
                                                            size="mini"
                                                            style="width: 225px;"
                                                            range-separator="至"
                                                            value-format="yyyy-MM-dd"
                                                            start-placeholder="开始时间"
                                                            end-placeholder="结束时间">
                                                    </el-date-picker>
                        </el-cal>
                        <!-- <el-col :span="7">
                            聘用形式:
                            <el-radio-group v-model="searchValue.engageForm">
                                <el-radio label="劳动合同">劳动合同</el-radio>
                                <el-radio label="劳务合同">劳务合同</el-radio>
                            </el-radio-group>
                        </el-col> -->
                    </el-row>
                    <el-row style="margin-top: 10px" type="flex" justify="end">
                        
   
                        <el-col :span="5" :offset="5">
                            <el-button size="mini">取消</el-button>
                            <el-button size="mini" icon="el-icon-search" type="primary" @click="initOfflineProjects('advanced')">搜索</el-button>
                        </el-col>
                    </el-row>
                </div>
            </transition>
        </div>
        <!-- 标题列 --->
        <div style="margin-top: 10px">
            <el-table
                    :data="projects"
                    border
                    :row-class-name="tableAddClass"
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    ref="projectTable"
                    style="width: 100%;"
                    :row-key="row=>row.pCode"
                    @selection-change="handleSelectionChange"
                    :header-cell-style="{'text-align':'center'}">
                   
                <!-- <el-table-column
                        type="selection" :reserve-selection="true"
                        width="55">
                </el-table-column> -->
                <el-table-column
                        prop="pNameNew"
                        fixed
                        align="center"
                        label="项目名称"
                        width="200">
                </el-table-column>
                <el-table-column
                        prop="place"
                        align="center"
                        label="执行地点"
                        width="140">
                </el-table-column>
                <el-table-column
                        prop="dockingPerson"
                        align="center"
                        label="对接人"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="pTime"
                        align="center"
                        label="项目入库时间"
                        width="110">
                </el-table-column>
                <el-table-column
                        prop="pStatus"
                        align="center"
                        label="项目状态"
                        width="80">
                        <template slot-scope="scope">
                             {{getChangeType(scope.row.pStatus,'pStatus')}}
                         </template>
                </el-table-column>
                <el-table-column
                        prop="pStartTime"
                        align="center"
                        label="执行开始时间"
                        width="110">
                </el-table-column>
                <el-table-column
                        prop="pEndTime"
                        align="center"
                        label="执行结束时间"
                        width="110">
                </el-table-column>
                <el-table-column
                        prop="invoiceStatus"
                        align="center"
                        label="开票状态"
                        width="80">
                        <template slot-scope="scope">
                             {{getChangeType(scope.row.invoiceStatus,'invoiceStatus')}}
                         </template>
                </el-table-column>
                <el-table-column
                        prop="arrivalSituation"
                        align="center"
                        label="到账状态"
                        width="80">
                        <template slot-scope="scope">
                             {{getChangeType(scope.row.arrivalSituation,'arrivalSituation')}}
                         </template>
                </el-table-column>
                <el-table-column
                        prop="remark"
                        align="center"
                        label="备注"
                        width="200">
                </el-table-column>
                <el-table-column
                        prop="budgutPrice"
                        align="center"
                        label="预计收款"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="budgutCost"
                        align="center"
                        label="预计成本"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="invoicePrice"
                        align="center"
                        label="开票金额"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="padedMoney"
                        align="center"
                        label="已到账金额"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="invoiceRemark"
                        align="center"
                        label="开票备注"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="reimbuseCost"
                        align="center"
                        label="报销金额"
                        width="120">
                </el-table-column>
                
                <el-table-column
                        prop="arrivalTime"
                        align="left"
                        label="到账时间"
                        width="110">
                </el-table-column>
                <el-table-column
                        prop="profitRate"
                        align="center"
                        label="收益率"
                        width="80">
                </el-table-column>
                <el-table-column
                        prop="cTime"
                        align="center"
                        label="创建时间"
                        width="220">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        align="center"
                        width="200"
                        label="操作">
                    <template slot-scope="scope">
                        <!-- <el-button @click="showEditEmpView(scope.row)" style="padding: 3px" size="mini" type="warning" v-has>锁定</el-button> -->
                        <el-button @click="showProjectDetail(scope.row)" style="padding: 3px" type="primary" size="mini">明细</el-button>
                        <el-button @click="showEditEmpView(scope.row)" style="padding: 3px" type="primary" size="mini">编辑</el-button>
                        <!-- <el-button style="padding: 3px" size="mini" type="primary">查看高级资料</el-button> -->
                        <el-button @click="deleteEmp(scope.row)" style="padding: 3px" size="mini" type="danger">删除
                        </el-button>  
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: flex-end">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog
                 title="项目报价单"
                label-width="80px"
                :modal-append-to-body="false"
                :close-on-click-modal="false"
                :visible.sync="showDetail"
                width="80%">
            <div style="display: flex;justify-content: center;">
                <div style="width:200px;">
                     报价单总金额：{{ project.budgutPrice }}
                </div>
                <div style="width:200px;">
                    成本：{{ project.budgutCost }}
                </div>
                <div style="width:200px;">
                    利润率：{{ ((1-project.budgutCost/project.budgutPrice)*100).toFixed(2) }}%
                </div>
            </div>
            <div style="display: flex;justify-content: center;margin-top: 20px;">
                <div style="width:200px;">
                    进场时间：<el-date-picker
                                                v-model="project.pDInTime"
                                                type="date"
                                                size="mini"
                                                style="width: 125px;"
                                                format="yyyy-MM-dd"
                                                value-format="yyyy-MM-dd"
                                                placeholder="进场时间">
                                        </el-date-picker>
                </div>
                <div style="width:200px;">
                    活动时间：<el-date-picker
                                                v-model="project.pDIngTime"
                                                type="date"
                                                size="mini"
                                                style="width: 125px;"
                                                format="yyyy-MM-dd"
                                                value-format="yyyy-MM-dd"
                                                placeholder="活动时间">
                                        </el-date-picker>
                </div>
                <div style="width:230px;">
                    详细执行地点：<el-input size="mini" style="width: 130px" v-model="project.pDPlace"
                                          placeholder="详细执行地点"></el-input>
                </div>
                <div style="width:200px;">
                    执行方：<el-select v-model="project.pDCompany" clearable="" placeholder="请选择" size="mini"
                                       style="width: 100px;">
                                <el-option
                                        key="0"
                                        label="扬帆永顺"
                                        :value="0">
                                </el-option>
                                <el-option
                                        key="1"
                                        label="博雅明德"
                                        :value="1">
                                </el-option>
                            </el-select>
                </div>
                <div style="width:290px;">
                    联系人和联系方式：<el-input size="mini" style="width: 160px" v-model="project.pDLink"
                                          placeholder="请输入单位" de></el-input>
                </div>
            </div>
            <div style="display: flex;justify-content: flex-end;margin-top: 10px;" >
                <div>
                    <el-button type="success"  @click="exportDill" icon="el-icon-download">
                        导出报价单
                    </el-button>
                </div>
                <div>
                    <el-button type="success" style="margin-left: 10px;" @click="addDetail" icon="el-icon-plus">
                        添加明细
                    </el-button>
                </div>
            </div>
        <!-- 明细标题列 --->
            <div style="margin-top: 10px;margin-bottom: 10px;">
                <el-table
                        :data="details"
                        stripe
                        border
                        v-loading="loading"
                        element-loading-text="正在加载..."
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                        ref="projectTable"
                        style="width: 100%;"
                        :row-key="row=>row.detailCode"
                        @selection-change="handleSelectionChange"
                        :header-cell-style="{'text-align':'center'}">
                    
                    <el-table-column
                            prop="detailName"
                            fixed
                            align="left"
                            label="物料名称"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="type"
                            align="center"
                            label="类型"
                            width="80">
                        <template slot-scope="scope">
                             {{getChangeType(scope.row.type,'detailType')}}
                         </template>
                    </el-table-column>
                    <el-table-column
                            prop="detailSpecs"
                            align="left"
                            label="规格"
                            width="380">
                    </el-table-column>
                    <el-table-column
                            prop="unit"
                            align="center"
                            label="单位"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="count"
                            align="center"
                            label="数量"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="price"
                            align="center"
                            label="单价"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="budgutPrice"
                            align="center"
                            label="总价"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="cTime"
                            align="center"
                            label="添加时间"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="costPrice"
                            align="center"
                            label="成本"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="pName"
                            align="center"
                            label="报价人"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            align="center"
                            width="150"
                            label="操作">
                        <template slot-scope="scope">
                            <el-button @click="putDetail(scope.row)" style="padding: 3px" type="primary" size="mini">编辑</el-button>
                            <el-button @click="deleteDetail(scope.row)" style="padding: 3px" size="mini" type="danger">删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>
        <el-dialog
                 :title="detailTitle"
                label-width="80px"
                :visible.sync="showChangeDetail"  
                width="40%"
                :modal-append-to-body="false"
                :close-on-click-modal="false"
                 >
                <el-form :model="detail" label-position="right" label-width="120px" :rules="rules" ref="empForm1">
                            <el-form-item label="物品名称:" prop="detailName">
                                <el-autocomplete
                                    class="inline-input"
                                    v-model="detail.detailName"
                                    :fetch-suggestions="querySearch"
                                    placeholder="请输入名称"
                                    @select="handleSelect"
                                    :popper-append-to-body="false"
                                    ></el-autocomplete>
                            </el-form-item>
                            <el-form-item label="规格:" prop="detailSpecs">
                                <el-autocomplete
                                    class="inline-input"
                                    v-model="detail.detailSpecs"
                                    :fetch-suggestions="querySearchSpecs"
                                    placeholder="请输入规格"
                                    @select="handleSelectSpecs"
                                    :popper-append-to-body="false"
                                    ></el-autocomplete>
                            </el-form-item>
                            <el-form-item label="单位:" prop="unit">
                                <el-input size="mini" style="width: 200px" prefix-icon="el-icon-edit" v-model="detail.unit"
                                          placeholder="请输入单位"></el-input>
                            </el-form-item>
                            <el-form-item label="执行类型:" prop="type">
                                <el-radio-group  style="line-height: 32px;" v-model="detail.type">
                                    <el-radio   :label="0">制作类</el-radio>
                                    <el-radio   :label="1">搭建类</el-radio>
                                    <el-radio   :label="2">运费</el-radio>
                                    <el-radio   :label="3">其他</el-radio>
                                </el-radio-group>
                            </el-form-item>

                            <el-form-item v-show="detail.type == 1&&detail.detailName&&detail.detailName.indexOf('桁')>-1" label="执行时间:">
                                    <el-form-item prop="upTime">
                                        <el-date-picker
                                                v-model="detail.upTime"
                                                type="datetime"
                                                size="mini"
                                                format="yyyy-MM-dd HH:mm"
                                                value-format="yyyy-MM-dd HH:mm:ss"
                                                placeholder="搭建时间">
                                        </el-date-picker>
                                    </el-form-item>
                                    <span style="margin: 0 18px 18px 18px;"> - </span>
                                    <el-form-item  prop="downTime">
                                        <el-date-picker
                                                v-model="detail.downTime"
                                                type="datetime"
                                                size="mini"
                                                format="yyyy-MM-dd HH:mm"
                                                value-format="yyyy-MM-dd HH:mm:ss"
                                                :picker-options="{
                                                    disabledDate: (time) => {
                                                        if(this.detail.upTime){
                                                            return time.getTime() <= new Date(this.detail.upTime).getTime()  
                                                        }
                                                    }
                                                }"
                                                placeholder="撤场时间">
                                        </el-date-picker>
                                    </el-form-item>
                            </el-form-item>


                            <el-form-item v-show="this.materials.length==0?false:true" label="项目类型:" prop="gov">
                                <el-radio-group  style="line-height: 32px;" v-model="detail.gov" @input="changeGov">
                                    <el-radio   label="0">企业</el-radio>
                                    <el-radio  label="1">政府</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="单价:" prop="price">
                                <el-input size="mini" style="width: 200px" prefix-icon="el-icon-edit" @change="staticPrice" v-model="detail.price"
                                          placeholder="请输入单价"></el-input>
                            </el-form-item>
                            <el-form-item label="数量:" prop="count">
                                <el-input size="mini" style="width: 200px" prefix-icon="el-icon-edit"  @change="staticPrice" v-model="detail.count"
                                          placeholder="请输入数量"></el-input>
                            </el-form-item>
                            <el-form-item label="总价:" prop="budgutPrice">
                                <el-input size="mini" readonly style="width: 200px"  v-model="detail.budgutPrice"
                                          placeholder=""></el-input>
                            </el-form-item>
                            <el-form-item label="总成本:" prop="costPrice">
                                <el-input size="mini"  style="width: 200px"  v-model="detail.costPrice"
                                          placeholder=""></el-input>
                            </el-form-item>
                    
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="cancelDetailEdit">取 消</el-button>
                    <el-button type="primary" @click="doAddDetail">确 定</el-button>
                </span>
            </el-dialog>




        <!-- 上传项目文件弹窗 -->
        <!--================================上传文件弹窗=========================-->
        <el-dialog :title="addFileTitleName" :modal-append-to-body="false"
                :close-on-click-modal="false" :visible.sync="importDataDisabled" width="500px" style="padding:0;" @close="resetAddFile" >
             <div class="add-file-right" >
                <!-- <el-col :span="24">
                    下单平台:<el-select v-model="upFilePlat" clearable="" placeholder="下单平台" size="mini">
                        <el-option
                                v-for="item in platList"
                                :key="item.dictValue"
                                :label="item.dictLabel"
                                :value="item.dictValue">
                        </el-option>
                    </el-select>
                </el-col> -->
            </div>
            <!-- <el-input v-model="addFileName" autocomplete="off" size="small" style="width: 300px; display: none;" ></el-input> -->
           
            <div class="add-file-right" style="margin-top: 20px;">
                <input type="file" ref="clearFile" @change="getFile($event)" multiple="multiplt" class="add-file-right-input" style="margin-left:60px;margin-top: 20px;" accept=".xlsx">
                <div style="margin-top: 20px;">
                    <span class="add-file-right-more">支持扩展名：.xlsx</span>
                </div>
                <div style="margin-top: 10px;">
                    <span class="add-file-right-more">注意：表中必须含有"项目名称"字段,前程和销售单需要注意</span>
                </div>
            </div>
            <div class="add-file-list">
                <ul>
                    <li v-for="(item, index) in addArr" :key="index"><a >{{item.name}}</a></li>
                </ul>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitAddFile" size="small">开始上传</el-button>
                <el-button @click="resetAddFile" size="small">全部删除</el-button>
            </div>
            
        </el-dialog>

        <!-- 修改和添加模块 -->
        <el-dialog
                :title="title"
                label-width="80px"
                :visible.sync="dialogVisible"
                :modal-append-to-body="false"
                :close-on-click-modal="false"
                width="30%">
            <div>
                <el-form :model="project"  label-width="120px" :rules="rules" ref="empForm">
                            <el-form-item label="项目名称:" prop="pName">
                                <el-input size="mini" style="width: 200px" prefix-icon="el-icon-edit" v-model="project.pName"
                                          placeholder="请输入项目名称"></el-input>
                            </el-form-item>
                            <el-form-item label="执行地点:" prop="place">
                                <el-autocomplete
                                    class="inline-input"
                                    v-model="project.place"
                                    :fetch-suggestions="querySearchPlace"
                                    placeholder="请输入执行地点"
                                    :popper-append-to-body="false"
                                    ></el-autocomplete>
                            </el-form-item>
                            <el-form-item label="对接人:" prop="dockingPerson">
                                <el-input size="mini" style="width: 200px" prefix-icon="el-icon-edit" v-model="project.dockingPerson"
                                          placeholder="请输入对接人"></el-input>
                            </el-form-item>
                            <el-form-item label="项目入库时间:" prop="pTime">
                                <el-date-picker
                                        v-model="project.pTime"
                                        size="mini"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        :picker-options="{
                                            disabledDate: (time) => {
                                                //只能选择今天以前
                                                return time.getTime() > Date.now() ;
                                            }
                                        }"
                                        style="width: 150px;"
                                        placeholder="项目入库时间">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="执行时间:">
                                <el-col :span="11">
                                    <el-form-item prop="pStartTime">
                                        <el-date-picker
                                                v-model="project.pStartTime"
                                                type="date"
                                                size="mini"
                                                value-format="yyyy-MM-dd"
                                                :picker-options="{
                                                    disabledDate: (time) => {
                                                        if(this.project.pTime){
                                                            return time.getTime() <= new Date(this.project.pTime).getTime() -3600*1000*24 
                                                        }
                                                    }
                                                }"
                                                placeholder="执行开始时间">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col class="line" :span="2">-</el-col>
                                <el-col :span="11">
                                    <el-form-item  prop="pEndTime">
                                        <el-date-picker
                                                v-model="project.pEndTime"
                                                type="date"
                                                size="mini"
                                                value-format="yyyy-MM-dd"
                                                :picker-options="{
                                                    disabledDate: (time) => {
                                                        if(this.project.pStartTime){
                                                            return time.getTime() <= new Date(this.project.pStartTime).getTime() -3600*1000*24
                                                        }
                                                    }
                                                }"
                                                placeholder="执行结束时间">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-form-item>
                            
                            
                            <el-form-item label="备注:" prop="remark">
                                <el-input type="textarea" size="mini" style="width: 200px" prefix-icon="el-icon-edit" v-model="project.remark"
                                          placeholder="备注"></el-input>
                            </el-form-item>
                        <!-- <el-col :span="7">
                            <el-form-item label="项目来源:" prop="source">
                                <el-select v-model="project.source" clearable="" placeholder="项目来源" size="mini">
                                    <el-option
                                            v-for="item in sourceList"
                                            :key="item.dictValue"
                                            :label="item.dictLabel"
                                            :value="item.dictValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col> -->
                      
                    
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="doAddEmp">确 定</el-button>
  </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "projectInfo",
        data() {
            return {
               
                searchValue: {
                    politicId: null,
                    nationId: null,
                    jobLevelId: null,
                    posId: null,
                    engageForm: null,
                    departmentId: null,
                    beginDateScope: null,
                    year:new Date()
                },
                pStatusList:[{
                    dictValue: '0',
                    dictLabel: '待立项'
                    }, {
                    dictValue: '1',
                    dictLabel: '待执行'
                    }, {
                    dictValue: '2',
                    dictLabel: '执行中'
                    }, {
                    dictValue: '3',
                    dictLabel: '待回款'
                    }, {
                    dictValue: '4',
                    dictLabel: '已完成'
                    }],
                invoiceStatusList:[{
                    dictValue: '0',
                    dictLabel: '未开票'
                    }, {
                    dictValue: '1',
                    dictLabel: '已开票'
                    }, {
                    dictValue: '2',
                    dictLabel: '部分开票'
                }],
                arrivalSituationList:[{
                    dictValue: '0',
                    dictLabel: '未到账'
                    }, {
                    dictValue: '1',
                    dictLabel: '已到账'
                    }, {
                    dictValue: '2',
                    dictLabel: '部分到账'
                }],
                detailTitle:'',
                showChangeDetail : false,
                showDetail : false,
                restaurants : [],
                restaurantsSpecs : [],
                places: [],
                user:"",
                title: '',
                pCode:'',
                importDataBtnText: '导入数据',
                importDataBtnIcon: 'el-icon-upload2',
                importDataDisabled: false,
                showAdvanceSearchView: false,
                allDeps: [],
                upFilePlat:'',
                addFileTitleName: "上传文件窗口",
                addFileName: "",
                addArr: [],
                projects: [],
                loading: false,
                popVisible: false,
                popVisible2: false,
                dialogVisible: false,
                total: 0,
                page: 1,
                keyword: '',
                size: 10,
                nations: [],
                joblevels: [],
                politicsstatus: [],
                positions: [],
                tiptopDegrees: ['本科', '大专', '硕士', '博士', '高中', '初中', '小学', '其他'],
                options: [ ],
                inputDepName: '所属部门',
                project: {
                
                },
                details:[],
                detail:{
                    count:1,
                    type:0,
                    gov:'0',
                    budgutPrice:'',
                    pCode:'',
                    unit:'',
                    price:'',
                    costPrice:''
                },
                materials:[],
                materialNameTemp:'',
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                rules: {
                    detailName: [{required: true, message: '请输入明细名', trigger: 'change'}],
                    price: [{required: true, message: '请输入单价', trigger: 'blur'},{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)|(^[0-9]\.[0-9]([0-9])([0-9])?$)/, message: '请输入正确的格式,可保留三位小数' }],
                    count: [{required: true, message: '请输入数量', trigger: 'blur'},{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])([0-9])?$)/, message: '请输入正确的格式,可保留三位小数' }],
                    pName: [{required: true, message: '请输入项目名', trigger: 'blur'}],
                    place: [{required: true, message: '请输入执行地点', trigger: 'blur'}],
                    pTime: [{required: true, message: '请输入入库日期', trigger: 'blur'}],
                    wedlock: [{required: true, message: '请输入婚姻状况', trigger: 'blur'}],
                    nationId: [{required: true, message: '请输入您组', trigger: 'blur'}],
                    nativePlace: [{required: true, message: '请输入籍贯', trigger: 'blur'}],
                    politicId: [{required: true, message: '请输入政治面貌', trigger: 'blur'}],
                    email: [{required: true, message: '请输入邮箱地址', trigger: 'blur'}, {
                        type: 'email',
                        message: '邮箱格式不正确',
                        trigger: 'blur'
                    }],
                    phone: [{required: true, message: '请输入电话号码', trigger: 'blur'}],
                    address: [{required: true, message: '请输入员工地址', trigger: 'blur'}],
                    departmentId: [{required: true, message: '请输入部门名称', trigger: 'blur'}],
                    jobLevelId: [{required: true, message: '请输入职称', trigger: 'blur'}],
                    posId: [{required: true, message: '请输入职位', trigger: 'blur'}],
                    engageForm: [{required: true, message: '请输入聘用形式', trigger: 'blur'}],
                    tiptopDegree: [{required: true, message: '请输入学历', trigger: 'blur'}],
                    specialty: [{required: true, message: '请输入专业', trigger: 'blur'}],
                    school: [{required: true, message: '请输入毕业院校', trigger: 'blur'}],
                    beginDate: [{required: true, message: '请输入入职日期', trigger: 'blur'}],
                    workState: [{required: true, message: '请输入工作状态', trigger: 'blur'}],
                    workID: [{required: true, message: '请输入工号', trigger: 'blur'}],
                    contractTerm: [{required: true, message: '请输入合同期限', trigger: 'blur'}],
                    conversionTime: [{required: true, message: '请输入转正日期', trigger: 'blur'}],
                    notworkDate: [{required: true, message: '请输入离职日期', trigger: 'blur'}],
                    beginContract: [{required: true, message: '请输入合同起始日期', trigger: 'blur'}],
                    endContract: [{required: true, message: '请输入合同结束日期', trigger: 'blur'}],
                    workAge: [{required: true, message: '请输入工龄', trigger: 'blur'}],
                }
            }
        },
        mounted() {
            this.initOfflineProjects();
            this.initData();
        },
        methods: {
            staticPrice(){
                if(this.materials.length == 0){
                    this.getBudgutPrice();
                    return
                }
                let tempMaterials = '';
                let minNum = this.materials[0];
                let maxNum = this.materials[0];
                for(let index in this.materials){
                    if(minNum.countMin>this.materials[index].countMin){
                        minNum = this.materials[index]
                    }
                    if(maxNum.countMax<this.materials[index].countMax){
                        maxNum = this.materials[index]
                    }
                    if(this.materials[index].countMin <= this.detail.count&&this.materials[index].countMax > this.detail.count){
                        tempMaterials = this.materials[index]
                    }
                }
                if(tempMaterials == ''){
                    if(minNum.countMin>=this.detail.count){
                        this.detail.count = minNum.countMin
                        tempMaterials =minNum
                    }else if(maxNum.countMax<=this.detail.count){
                       tempMaterials = maxNum
                    }
                }
                if(this.detail.price>0&&this.detail.price !=tempMaterials.price){

                }else  if(this.detail.gov&&this.detail.gov == '0'){
                    this.detail.price = tempMaterials.price;
                }else{
                    this.detail.price = tempMaterials.priceGov;
                }
                this.getBudgutPrice();
            },
            changeGov(){
                this.staticPrice();
            },
            getBudgutPrice(){
                if(this.detail.price&&this.detail.count){
                    this.detail.budgutPrice =  this.NumberMul(this.detail.price , this.detail.count);
                }else{
                    this.detail.budgutPrice =  '';
                }
            },
            handleSelectSpecs(item){
                console.log(item.value);
                if(item.value == "无"){
                    item.value = undefined;
                }
                this.postRequest("/yl/offline/materials", {materialName:this.materialNameTemp,materialSpecs:item.value}).then(resp => {
                                if (resp) {
                                    this.materials = resp.data;
                                    if(this.materials.length >= 1){
                                        this.detail.unit = this.materials[0].unit
                                        this.detail.price = this.materials[0].price
                                    }
                                    this.staticPrice();
                                }
                            })
               
            },
            handleSelect(item){
                this.materialNameTemp = item.value;
                this.postRequest("/yl/offline/material/specs", {materialName:item.value}).then(resp => {
                                if (resp) {
                                    this.restaurantsSpecs = resp.data;
                                    if(resp.data.length == 1 && !resp.data[0].value){
                                        this.restaurantsSpecs = [{value:'无'}]
                                    }
                                }
                            })
                this.rules.detailSpecs = [{required: true, message: '请选择明细名', trigger: 'blur'}];
            },
            querySearchPlace(queryString, cb) {
                var restaurants = this.places;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            querySearchSpecs(queryString, cb) {
                var restaurants = this.restaurantsSpecs;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            querySearch(queryString, cb) {
                var restaurants = this.restaurants;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
                };
            },
            putDetail(row){
                this.detailTitle = '编辑明细';
                this.detail = row;
                this.materialNameTemp = row.detailName;
                this.handleSelectSpecs({value:row.detailSpecs});
                this.showChangeDetail = true;
                // this.postRequest("/yl/offline/material/names", {}).then(resp => {
                //                 if (resp) {
                //                     this.restaurants = resp.data;
                //                 }
                //             })
            },
            addDetail(){
                this.detailTitle = '添加明细';
                this.showChangeDetail = true;
                this.postRequest("/yl/offline/material/names", {}).then(resp => {
                                if (resp) {
                                    this.restaurants = resp.data;
                                }
                            })
            },
            cancelDetailEdit(){
                this.showChangeDetail = false;
                this.emptyDetail();
            },
            searvhViewHandleNodeClick(data) {
                this.inputDepName = data.name;
                this.searchValue.departmentId = data.id;
                this.popVisible2 = !this.popVisible2
            },
            rowKey(row){
                console.log( row.projectCode)
                row.projectCode;
            },
            handleSelectionChange (val) {
                console.log(val)
            },
            tableAddClass({row,rowIndex}) {
                if (row.pStatus == '0') {
                    return 'tr-gray';
                }else if(row.pStatus == '1'){
                    return 'tr-blue';
                }else if(row.pStatus == '2'){
                    return 'tr-green';
                }else if(row.pStatus == '3'){
                    return 'tr-yellow';
                }else {
                    return '';
                }
            },
            //1、使用插槽（推荐）
            getChangeType(e,z) {

                if('arrivalSituation' == z){
                    for (var i = 0; i < this.arrivalSituationList.length; i++) {
                        if (this.arrivalSituationList[i].dictValue == e) { //dictValue，dictLabel保持和上面定义一致
                            return this.arrivalSituationList[i].dictLabel;
                        }
                    }
                }else if('pStatus' == z){
                    for (var i = 0; i < this.pStatusList.length; i++) {
                        if (this.pStatusList[i].dictValue == e) { //dictValue，dictLabel保持和上面定义一致
                            return this.pStatusList[i].dictLabel;
                        }
                    }
                }else if('invoiceStatus' == z){
                    for (var i = 0; i < this.invoiceStatusList.length; i++) {
                        if (this.invoiceStatusList[i].dictValue == e) { //dictValue，dictLabel保持和上面定义一致
                            return this.invoiceStatusList[i].dictLabel;
                        }
                    }
                }else if('detailType' == z){
                        if ('0' == e) { //dictValue，dictLabel保持和上面定义一致
                            return '制作类';
                        }else if('1' == e){
                            return '搭建类';
                        }else if('2' == e){
                            return '运费';
                        }else if('3' == e){
                            return '其他';
                        }
                }
               
            },

            onError(err, file, fileList) {
                this.importDataBtnText = '导入数据';
                this.importDataBtnIcon = 'el-icon-upload2';
                this.importDataDisabled = false;
            },
            onSuccess(response, file, fileList) {
                this.importDataBtnText = '导入数据';
                this.importDataBtnIcon = 'el-icon-upload2';
                this.importDataDisabled = false;
                this.initOfflineProjects();
            },
            beforeUpload() {
                this.importDataBtnText = '正在导入';
                this.importDataBtnIcon = 'el-icon-loading';
                this.importDataDisabled = true;
            },
            importData(){
                this.importDataDisabled = true;
            },
            exportDill() {
                this.putRequest("/yl/offline/project/expHead", this.project).then(resp => {
                                if (resp) {
                                    window.open('/yl/offline/export/' + this.pCode, '_parent');
                                }
                            })
                
            },
            exportTask() {
                let selected = this.$refs.projectTable.selection
                let arr = [];
                for(let temp in selected){
                    arr.push(selected[temp].projectCode)

                }
                window.open('/employee/basic/export', '_parent');
            },
            emptyEmp() {
                this.project = {
                    "id":"",
                    "pCode":"",
                    "pName":"",
                    "place":"",
                    "dockingPerson":"",
                    "pTime":"",
                    "pStartTime":"",
                    "pEndTime":"",
                    "budgutPrice":"",
                    "invoicePrice":"",
                    "padedMoney":"",
                    "invoiceRemark":"",
                    "budgutCost":"",
                    "reimbuseCost":"",
                    "arrivalSituation":"",
                    "arrivalTime":"",
                    "remark":"",
                    "profitRate":"",
                    "lockStatue":"",
                    "invoiceStatus":"",
                    "pStatus":"",
                    "cTime":"",
                    "gTime":""
                }
                this.inputDepName = '';
            },
            showProjectDetail(data){
                this.showDetail = true;
                this.detail.pCode = data.pCode;
                this.pCode = data.pCode;
                this.project = data;
                this.project.pDCompany =  this.project.pDCompany =='0'?'扬帆永顺':'博雅明德'
                this.project.pDLink='杨斌 13820251532';
                this.initDetails();
            },
            initDetails(){
                this.getRequest("/yl/offline/details/"+this.pCode).then(resp => {
                    if (resp) {
                        this.details = resp.data;
                    }
                })
            },
            showEditEmpView(data) {
                 
                this.title = '编辑项目信息';
                this.project = data;
                // this.inputDepName = data.department.name;
                this.dialogVisible = true;
            },
            deleteDetail(data){
                this.$confirm('此操作将永久删除【' + data.detailName + '】, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteRequest("/yl/offline/detail/" + data.detailCode).then(resp => {
                        if (resp) {
                            this.initDetails();
                            this.initOfflineProjects();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            deleteEmp(data) {
                this.$confirm('此操作将永久删除【' + data.name + '】, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteRequest("/employee/basic/" + data.id).then(resp => {
                        if (resp) {
                            this.initOfflineProjects();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            doAddDetail() {
                this.detail.pId = this.user.username;
                this.detail.pName = this.user.name;
                if (this.detail.id) {
                    this.$refs['empForm1'].validate(valid => {
                        if (valid) {
                            this.putRequest("/yl/offline/project/detail", this.detail).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initOfflineProjects();
                                    this.initDetails();
                                }
                            })
                        }
                    });
                } else {
                    this.$refs['empForm1'].validate(valid => {
                        if (valid) {
                            this.postRequest("/yl/offline/project/detail", this.detail).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initOfflineProjects();
                                    this.initDetails();
                                }
                            })
                        }
                    });
                }
                this.showChangeDetail = false;
                this.emptyDetail();
            },
            emptyDetail(){
                this.detail={
                    count:1,
                    detailName:'',
                    type:0,
                    gov:'0',
                    budgutPrice:'',
                    pCode:this.pCode,
                    unit:'',
                    price:'',
                    costPrice:''
                }
            },
            doAddEmp() {
                if (this.project.id) {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.putRequest("/yl/offline/project", this.project).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initOfflineProjects();
                                }
                            })
                        }
                    });
                } else {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/yl/offline/project", this.project).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initOfflineProjects();
                                }
                            })
                        }
                    });
                }
            },
            handleNodeClick(data) {
                this.inputDepName = data.name;
                this.project.departmentId = data.id;
                this.popVisible = !this.popVisible
            },
            showDepView() {
                this.popVisible = !this.popVisible
            },
            showDepView2() {
                this.popVisible2 = !this.popVisible2
            },
            initData() {
                this.user = JSON.parse(window.sessionStorage.getItem("user"));
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initOfflineProjects();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initOfflineProjects('advanced');
            },
            showAddEmpView() {
                this.emptyEmp();
                this.title = '添加项目';
                this.dialogVisible = true;
            },
            initOfflineProjects(type) {
                this.loading = true;
                // let reqParam = {projectNameLike:this.keyword};
                this.searchValue['projectNameLike']=this.keyword
                this.searchValue['pageNo']=this.page
                this.searchValue['pageSize']=this.size
                this.searchValue['orderByClause']=' c_time desc '
                this.postRequest('/yl/offline/projects', this.searchValue).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.projects = resp.data;
                        for(let index in  this.projects){
                                let temp = this.projects[index];
                                temp.pNameNew = temp.pTime+" " + temp.pName;
                        }
                        if(this.project.id){
                            for(let index in  this.projects){
                                let temp = this.projects[index];
                                temp.pNameNew = temp.pTime+" " + temp.pName;
                                if(this.project.pCode ==  this.projects[index].pCode){
                                    this.project = this.projects[index]
                                }
                            }
                        }
                        this.total = resp.total;
                    }
                });

                this.getRequest('/yl/offline/project/places').then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.places = resp.obj;
                    }
                });

                
            },
            //==================上传文件操作函数=============================================
            getFile(event){  
                //获取上传文件方法    
                var file = event.target.files;    
                for(var i = 0;i<file.length;i++){        
                    //    上传类型判断        
                    var imgName = file[i].name;        
                    var idx = imgName.lastIndexOf(".");        
                    if (idx != -1){            
                        var ext = imgName.substr(idx+1).toUpperCase();            
                        ext = ext.toLowerCase( );            
                        //pdg,doc,docx.xls,.xlsx,.ppt,pptx,            
                        if (ext!='xlsx'){

                        }else{
                            this.addArr.push(file[i]);            
                        }        
                    }else{        

                    }    
                }},
            submitAddFile(){    
                //===========提交上传文件到后台保存方法    
                if(0 == this.addArr.length){        
                    this.$message({            
                        type: 'info',            
                        message: '请选择要上传的文件'        
                    });        
                    return;    
                }    
                var formData = new FormData();    
                for(var i=0;i<this.addArr.length;i++){        
                    formData.append('files',this.addArr[i]); 
                }  
                formData.append('plat',this.upFilePlat);      
                let config = {        
                    headers: { "Content-Type": "multipart/form-data" }    
                };    
                console.log(formData);　　
                //接口请求使用的是自己封装了一下的axios    
                this.postRequest('/yl/qun/importProject', formData, config).then(res => {
                    console.log(res);        
                    this.$message({            
                        message: '操作成功',            
                        type: 'success'        
                    });    
                }).catch((error) => {        
                    alert("操作失败，出现错误：" + error)    
                });
            },
            //清除上传的文件方法
            resetAddFile(){   
                this.addFileName = "";    
                this.addArr =[];
                this.upFilePlat = "";
                this.$refs.clearFile.value =''
            },

        }
    }
</script>

<style>
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
    .tr-gray{
        background-color: #c0c4cc !important;
    }
    .tr-blue{
        background-color: #B2E0FF !important;
    }
    .tr-green{
        background-color: #9EEA6A !important;
    }
    .tr-yellow{
        background-color: #FED55F !important;
    }
    .el-radio{
        margin-top: 8px !important;
    }
    .el-autocomplete-suggestion{
        width: auto!important;
    }
    .el-table__fixed-right {
        height: 100% !important;
    }
    .el-table__fixed{
        height: 100% !important;
    }

</style>
